module.exports = __webpack_public_path__ + "static/img/analyzer4.1be95e91.png";